import React from 'react';
// import { FormattedMessage } from 'react-intl';

const NotFound = props => (
	<header><h1>Not found</h1></header>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js